import { User, Workspace, ApiResponse, LoginForm } from '@/types';
import api from './client';

// Auth API
export const authAPI = {
  login: async (credentials: LoginForm): Promise<ApiResponse<{ token: string; user: User; workspaces: Workspace[] }>> => {
    const response = await api.post('/auth/login', credentials);
    // Backend returns { token, user }; frontend expects { data: { token, user } }
    return { data: response.data };
  },

  logout: async (): Promise<void> => {
    await api.post('/auth/logout');
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('workspaces');
    localStorage.removeItem('currentWorkspaceId');
  },

  refresh: async (): Promise<ApiResponse<{ token: string }>> => {
    const response = await api.post('/auth/refresh');
    return response.data;
  },
  stopImpersonation: async (): Promise<{ token: string; user: any; workspaces: any[] }> => {
    const response = await api.post('/auth/stop-impersonation');
    return response.data;
  },
};
